import { combineReducers } from "redux";
import globalReducer from "./globalReducer";
import homeReducer from "./homeReducer";
import ProfileDetailsReducer from "./ProfileDetailsReducer";
import StaffDetailsReducer from "./StaffDetailsReducer";
import profileVerificationReducer from "./profileVerificationReducer";
import PaymentDetailsReducer from "./PaymentDetailsReducer";
import InfrastructureDetailsReducer from "./InfrastructureDetailsReducer";
import providerPortalDetailReducer from "./providerPortalDetailReducer";
import HelloAdminReducer from "./HelloAdminReducer";
import AppoinmentReducer from "./AppoinmentReducer";
import ReportReducer from "./ReportReducer";
import TestPackageReducer from "./TestPackageReducer";
import NetworkIntelligenceReducer from "./NetworkIntelligenceReducer";
import TestPackageCreationReducer from "./TestPackageCreationReducer";
import PayoutReducer from "./PayoutReducer"
import InsBillingPayout from "./InsBillingPayout";

export default combineReducers({
  globalReducer,
  homeReducer,
  ProfileDetailsReducer,
  StaffDetailsReducer,
  profileVerificationReducer,
  PaymentDetailsReducer,
  InfrastructureDetailsReducer,
  providerPortalDetailReducer,
  AppoinmentReducer,
  ReportReducer,
  HelloAdminReducer,
  TestPackageReducer,
  NetworkIntelligenceReducer,
  TestPackageCreationReducer,
  PayoutReducer,
  InsBillingPayout
});
